import type { ReactNode } from 'react';

export interface LessonPageHeaderProps {
  title: string;
  subtitle?: string;
  /** Rendered after the title inside the h1 (e.g. the success check). */
  adornment?: ReactNode;
}

export function LessonPageHeader({ title, subtitle, adornment }: LessonPageHeaderProps) {
  return (
    <div className="mb-12 lg:mb-18">
      <h1
        className="flex items-center gap-4 text-4xl font-semibold leading-tight text-butter-gray-900 sm:text-5xl lg:text-6xl lg:leading-tight"
        data-testid="lessons-page-title"
      >
        {title}
        {adornment}
      </h1>
      {subtitle && (
        <p className="mt-4 text-lg font-semibold leading-snug text-butter-gray-600">{subtitle}</p>
      )}
    </div>
  );
}
